// The canonical identity of a reticulation edge: its unordered endpoint pair. Spool ids are random
// GUIDs and carry no meaning, so an edge is looked up by this key instead.
//
// The separator is U+0000 because a node id may legitimately contain spaces and hyphens — the
// historic `${a} - ${b}` convention silently mis-parsed those. Kept behaviourally identical to the
// backend's NodePairKey.For (ordinal comparison, same separator).
const pairKey = (nodeAId: string, nodeBId: string): string => (nodeAId <= nodeBId
  ? `${nodeAId}\u0000${nodeBId}`
  : `${nodeBId}\u0000${nodeAId}`);

export default pairKey;
